export default __webpack_public_path__ + "static/media/nissan.99889ed9.svg";